import { useEffect, useState } from "react";
import "./header.style.scss";
import { NavLink } from "react-router-dom";
import { FaHome, FaUsers, FaBookOpen, FaCalendarAlt, FaChalkboardTeacher, FaHandPointUp, FaClipboardList, FaVideo } from "react-icons/fa";
import { Tooltip } from 'antd';


export const HeaderScc = () => {
  return null;
};

